<script>
import {
    mapGetters
} from 'vuex';
export default {
    name: 'ProcessesDataProvider',
    computed: mapGetters('processes', {
        processes: 'processes',
        loading: 'loading',
        originalProcessIds: 'originalProcessIds'
    }),
    render() {
        if (!this.$scopedSlots.default) {
            return;
        }

        const slotScope = {
            processes: this.processes,
            loading: this.loading,
            originalProcessIds: this.originalProcessIds
        };

        return this.$scopedSlots.default(slotScope);
    },
    created() {
		this.$store.dispatch('processes/fetchProcesses');
    }
}
</script>
